export default __webpack_public_path__ + "static/card-img04-bd28c7e4da9c96dd7e85106e09d30b30.jpg";